import { LOAN_DENIAL_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = [];

const loanDenialReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_DENIAL_ACTION_TYPE.GET_LOAN_DENIAL_REASONS:
    case LOAN_DENIAL_ACTION_TYPE.UPDATE_LOAN_DENIAL_REASONS:
      return payload || state;

    default:
      return state;
  }
};

export default loanDenialReducer;
